/**
 * 组件库入口
 * */
// 基础组件

import MkEditDiv from "./MkEditDiv"; // 必须放第一个位置引入 因为下面的组件有用到它
import MkImage from "./MkImage";
import MkButton from "./MkButton";
import MkText from "./MkText";
import MkContainer from "./MkContainer";

import MkFormPhone from "./TemplatePhone/form";
import MkHeaderPhone from "./TemplatePhone/header";
import MkSearchPhone from "./TemplatePhone/search";
import MkBannerPhone from "./TemplatePhone/banner";
import MkBanner2Phone from "./TemplatePhone/banner2";
import MkBaipishuPhone from "./TemplatePhone/baipishu";
import MkImageBlockPhone from "./TemplatePhone/image-block";
import MkImageIconPhone from "./TemplatePhone/image-icon";
import MkImageGroupPhone from "./TemplatePhone/image-group";
import MkContentGroupPhone from "./TemplatePhone/content-group";
import MkContentCardPhone from "./TemplatePhone/content-card";
import MkLianghuashujuPhone from "./TemplatePhone/lianghuashuju";
import MkYingyongchangjingPhone from "./TemplatePhone/yingyongchangjing";
import MkFuwujiazhiPhone from "./TemplatePhone/fuwujiazhi";
import MkKehuanliPhone from "./TemplatePhone/kehuanli";
import MkXiangguanchanpinPhone from "./TemplatePhone/xiangguanchanpin";

import MkFormWeb from "./TemplateWeb/form";
import MkHeaderTopWeb from "./TemplateWeb/headerTop";
import MkHeaderWeb from "./TemplateWeb/header";
import MkHeader2Web from "./TemplateWeb/header2";
import MkBannerWeb from "./TemplateWeb/banner";
import MkBanner2Web from "./TemplateWeb/banner2";
import MkBaipishuWeb from "./TemplateWeb/baipishu";
import MkBaipishuMultipleWeb from "./TemplateWeb/baipishu-multiple";
import MkLianghuashujuWeb from "./TemplateWeb/lianghuashuju";
import MkImageBlockWeb from "./TemplateWeb/image-block";
import MkImageHoverWeb from "./TemplateWeb/image-hover";
import MkVideoTextWeb from "./TemplateWeb/video-text";
import MkYingyongchangjingWeb from "./TemplateWeb/yingyongchangjing";
import MkYingyongchangjing2Web from "./TemplateWeb/yingyongchangjing2";
import MkFuwujiazhiWeb from "./TemplateWeb/fuwujiazhi";
import MkKehuanliWeb from "./TemplateWeb/kehuanli";
import MkTabRightWeb from "./TemplateWeb/tab-right";
import MkXiangguanchanpinWeb from "./TemplateWeb/xiangguanchanpin";
import MkPhonebottomWeb from "./TemplateWeb/phonebottom";
import MkPhonebottom2Web from "./TemplateWeb/phonebottom2";
import MkFooterWeb from "./TemplateWeb/footer";
import MkFooterMenuWeb from "./TemplateWeb/footermenu";
import MkSemBlockWeb from "./TemplateWeb/semBlock";

import MkArticleListWeb from "./TemplateWeb/article-list";
import MkProductTrialWeb from "./TemplateWeb/product-trial";

// 所有组件列表
const components = [
  MkEditDiv,
  MkImage,
  MkButton,
  MkText,
  MkContainer,
  MkFormWeb,
  MkHeaderTopWeb,
  MkHeaderWeb,
  MkHeader2Web,
  MkBannerWeb,
  MkBanner2Web,
  MkBaipishuWeb,
  MkBaipishuMultipleWeb,
  MkLianghuashujuWeb,
  MkImageBlockWeb,
  MkImageHoverWeb,
  MkVideoTextWeb,
  MkYingyongchangjingWeb,
  MkYingyongchangjing2Web,
  MkFuwujiazhiWeb,
  MkKehuanliWeb,
  MkTabRightWeb,
  MkXiangguanchanpinWeb,
  MkPhonebottomWeb,
  MkPhonebottom2Web,
  MkFooterWeb,
  MkFooterMenuWeb,
  MkSemBlockWeb,
  MkArticleListWeb,
  MkProductTrialWeb,

  MkFormPhone,
  MkHeaderPhone,
  MkSearchPhone,
  MkBannerPhone,
  MkBanner2Phone,
  MkImageBlockPhone,
  MkImageIconPhone,
  MkImageGroupPhone,
  MkContentGroupPhone,
  MkContentCardPhone,
  MkBaipishuPhone,
  MkLianghuashujuPhone,
  MkYingyongchangjingPhone,
  MkFuwujiazhiPhone,
  MkKehuanliPhone,
  MkXiangguanchanpinPhone,
];

let plRegisterComponentsObject = {};
let componentsName = [];

components.forEach((item) => {
  plRegisterComponentsObject[item.name] = item;
  // 导出当前组件的组件名
  if (item.name && typeof item.name === "string") {
    componentsName.push(item.name.toLowerCase());
  }
});

// 定义 install 方法，接收 Vue 作为参数
const install = function (Vue) {
  // 判断是否安装，安装过就不继续往下执行
  if (install.installed) return;
  install.installed = true;
  // 遍历注册所有组件
  components.map((component) => Vue.component(component.name, component));
};

export {
  componentsName,
  MkEditDiv,
  MkContainer,
  MkImage,
  MkButton,
  MkText,
  plRegisterComponentsObject,
};

export default {
  install,
};
